import React, { FC, useEffect, useState } from 'react';
import { SiPayModal } from 'utilities/components';
import { __FirstTimeVideoModalProps } from './firstTimeVideoModal.type';

export const FirstTimeVideoModal: FC<__FirstTimeVideoModalProps> = (props: __FirstTimeVideoModalProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);

    useEffect(() => {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);

    return (
        <SiPayModal maxWidth={600} isOpen={isOpen} onClose={props.onClose} title={props.title}>
            <div className="relative w-full pb-[75%]">
                <video className="absolute top-0 left-0 w-full h-full rounded-lg" controls autoPlay>
                    <source src={props.src} type={props.videoType ?? 'video/mp4'} />
                    مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
                </video>
            </div>
            {props.description && <p className="text-center mt-6 text-base text-darkPurple-100">{props.description}</p>}
        </SiPayModal>
    );
};
